import React from 'react';
import SignUpForm from '../SignUpForm';
import { useWebContents } from '../../hooks/useWebContents';
import { useImages } from '../../hooks/useImages';

const GUIDS = {
  stayInTheKnow: '24e59d09-bb50-4ac7-b9df-ffc6b6abf87a',
};

const StayInTheKnow: React.FC = () => {
  const contents = useWebContents(GUIDS, 'Home');
  const stayInTheKnowImage = useImages(GUIDS.stayInTheKnow);

  return (
    <section
      id='stayInTheKnow'
      className="scroll-mt-24 w-full bg-cover bg-center py-20 flex flex-col items-center px-4 mb-12"
      style={{
        backgroundImage:  `url(${stayInTheKnowImage?.image})`,
        backgroundBlendMode: 'multiply',
      }}
    >
      <SignUpForm
        heading={contents.stayInTheKnow.heading}
        subheading={contents.stayInTheKnow.content}
      />
    </section>
  )
};

export default StayInTheKnow;